import { render, staticRenderFns } from "./EditableAdsImage.vue?vue&type=template&id=40836c71&scoped=true"
import script from "./EditableAdsImage.vue?vue&type=script&lang=js"
export * from "./EditableAdsImage.vue?vue&type=script&lang=js"
import style0 from "./EditableAdsImage.vue?vue&type=style&index=0&id=40836c71&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40836c71",
  null
  
)

export default component.exports